/* @flow */
import cx from 'classnames';
import * as React from 'react';

import Image from 'components/Image';
import EngagementRatings from 'schools/constants/EngagementRatings';

import type { EngagementRating } from 'schools/constants/EngagementRatings';

import './SchoolEngagementBadge.scss';

type Props = {
  alt?: ?string,
  className?: string,
  onClick?: () => void,
  rating?: EngagementRating,
  size?: string,
};

export default function SchoolEngagementBadge({ alt, className, onClick, rating, size }: Props) {
  if (!rating) {
    return null;
  }

  return (
    <button
      className={cx('SchoolEngagementBadge', size && `SchoolEngagementBadge--${size}`, className)}
      onClick={onClick}>
      <Image src={EngagementRatings.BADGES[rating].svg} alt={alt || ''} />
    </button>
  );
}

SchoolEngagementBadge.defaultProps = {
  alt: 'Your organization’s engagement rating badge',
  size: 'large',
};
